'use strict';

angular.module('app.deleteAdvertiserFromAgency', [])
	.controller('deleteAdvertiserFromAgencyCtrl', ['$scope', '$modal', '$modalInstance', 'deleteAdvertiserFromAgencyService',
		function ($scope, $modal, $modalInstance, deleteAdvertiserFromAgencyService) { 
		    
		    $scope.confirmDelete = function () {
		    	deleteAdvertiserFromAgencyService.deleteAdvertiserFromAgency($scope.company_id, true)
		    		.then(function(responseDeleteAdvertiser) {
		    			$scope.deleteAdvertiserFromAgencyModalInstance.close(function () {
			                $log.info('Close Modal now');
			            })
		    		}, function(responseDeleteAdvertiser) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseDeleteAdvertiser.message;
		    		})
		    }

		    $scope.closeModal = function () {
		        $modalInstance.close();
		    }
    
}])